import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ROUTE_PATHS } from "@/lib/index";
import Home from "@/pages/Home";
import Diagnosis from "@/pages/Diagnosis";
import Products from "@/pages/Products";
import Management from "@/pages/Management";
import About from "@/pages/About";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner position="top-center" expand={false} richColors />
        <BrowserRouter>
          <Routes>
            <Route path={ROUTE_PATHS.HOME} element={<Home />} />
            <Route path={ROUTE_PATHS.DIAGNOSIS} element={<Diagnosis />} />
            <Route path={ROUTE_PATHS.PRODUCTS} element={<Products />} />
            <Route path={ROUTE_PATHS.MANAGEMENT} element={<Management />} />
            <Route path={ROUTE_PATHS.ABOUT} element={<About />} />
            <Route
              path="*"
              element={
                <div className="flex flex-col items-center justify-center min-h-screen bg-background text-foreground">
                  <h1 className="text-4xl font-bold mb-4">404</h1>
                  <p className="text-muted-foreground mb-8">요청하신 페이지를 찾을 수 없습니다.</p>
                  <a
                    href={ROUTE_PATHS.HOME}
                    className="px-6 py-2 bg-primary text-primary-foreground rounded-md hover:opacity-90 transition-opacity"
                  >
                    홈으로 돌아가기
                  </a>
                </div>
              }
            />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;